import {
  TCsvDatetimeFormatTranslations,
} from './select-csv-datetime-format.ts';

const options: TCsvDatetimeFormatTranslations = {
  iso_8601: 'ISO 8601 / RFC 3339',
  unix_timestamp: 'UNIX Zeitstempel',
  us: 'US',
};

export default {
  placeholder: '',
  label: 'Zeitformat',
  options,
};
